import React from 'react'
import { useIntl } from 'react-intl'
import ButtonCinestar from '../../../../../components/Buttons/ButtonCinestar/ButtonCinestar'

export default function OrderMembershipButton({ cardsInBasket, setShowRegistration, removeCard }) {
    const intl = useIntl()
    return (
        <>
            {!cardsInBasket?.[0] ? (
                <ButtonCinestar variant={'primary-v1'} className={'text-uppercase'} onClick={setShowRegistration}>
                    {intl.formatMessage({ id: 'buttons.orderMembership' }, { span: (chunks) => <span>{chunks}</span> })}
                </ButtonCinestar>
            ) : (
                <ButtonCinestar variant={'primary-v1'} className={'text-uppercase'} onClick={removeCard}>
                    {intl.formatMessage(
                        { id: 'buttons.orderMembershipRemove' },
                        { span: (chunks) => <span>{chunks}</span> }
                    )}
                </ButtonCinestar>
            )}
        </>
    )
}
